import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
* {
  margin: 0;
  padding: 0;
  scroll-behavior: smooth;
  box-sizing: border-box;
  scroll-behavior: smooth;
  font-family: "Cormorant Garamond", serif, "Merriweather", serif, "Open Sans",
    sans-serif, "Roboto Condensed", sans-serif, "Roboto Mono", monospace;
}

:root {
  --primary: #fff;
  --text: #000;
  --neutral: #9a9a9a;
  --custom: #23cbf5;
}

body {
  font-family: "Cormorant Garamond", serif, "Merriweather", serif, "Open Sans",
    sans-serif, "Roboto Condensed", sans-serif, "Roboto Mono", monospace;
  font: "Cormorant Garamond", serif, "Merriweather", serif, "Open Sans",
    sans-serif, "Roboto Condensed", sans-serif, "Roboto Mono", monospace;
}

@media (prefers-color-scheme: dark) {
  :root {
    --text: #fff;
    --primary: #000;
    --neutral: #9a9a9a;
    --custom: #23cbf5;
  }
}




`;
